<section id="footer-secondary-brand-funnels" class="bg-overlay">
    <div class="funnel35-footer">
      <div class="col-12 text-center pt-4">
        <small class="text-white">
          <div *ngIf="IsOrganicFunnel">
          <p class="text-white">*Scores and rankings shown above are examples only.</p>
          <p class="py-2 text-white">*Your lender and insurer might use a different scoring model, or another type
            of credit score altogether.</p></div>
          <a class="text-decoration-none text-white fw-bold mx-2 col-sm-6 col-md-12" routerLink="/terms"
            target="_blank" id="link-terms-and-conditions" lander-checkout-partner-terms-link>Terms & Conditions</a> |
          <a class="text-decoration-none text-white fw-bold mx-2 col-sm-6 col-md-4" routerLink="/privacy"
            target="_blank" id="link-privacy-policy" lander-checkout-partner-privacy-link>Privacy Policy</a> |
          <a class="text-decoration-none text-white fw-bold mx-2 col-sm-6 col-md-4" [routerLink]="'/contact'"
            target="_blank" id="link-contact-us">Contact Us</a> |
          <a class="text-decoration-none text-white fw-bold mx-2 col-sm-6 col-md-4" [routerLink]="'/contact'"
            target="_blank" id="link-cancel-subscription">Cancel</a> |
          <a class="text-decoration-none text-white fw-bold mx-2 col-sm-6 col-md-4" href="{{brandResources.loginURL}}"
            target="_blank">Login</a>
          <br>
        </small>
      </div>
      <div class="col-12 text-center pt-5 pb-3 container-logos">
        <div><img loading="lazy" src="assets/images/funnels/Inc5000-logo.png" width="75"></div>
        <img loading="lazy" [src]="environment.assetsURL + 'img/logos/lets-encrypt.webp'" width="280" height="104"  class="footer-lets-encrypt" />
      </div>
      <div class="col-12">
        <small>
          <p class="p-3 m-0 text-white">© {{ currentYear }} {{ brandResources.companyTitle! }}. All rights
            reserved.</p>
        </small>
      </div>
    </div>
  </section>